import { render } from "./ProductsIcon.vue?vue&type=template&id=6778ec9e"
import script from "./ProductsIcon.vue?vue&type=script&lang=js"
export * from "./ProductsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__